export interface Model {
    requestType: string,
    namePrefix: string,
    nameFirst: string,
    nameMiddle: string,
    nameLast: string,
    nameSuffix: string,
    contactEmail: string,
    contactPhone: string,
    addressLine1: string,
    addressLine2: string,
    addressCity: string,
    addressState: string,
    addressZIP: string,
    contactBy: string,
    acceptDisclaimer: boolean,

    firstStepComplete: () => boolean,
    secondStepComplete: () => boolean,
    thirdStepComplete: () => boolean,
    fourthStepComplete: () => boolean,
    fifthStepComplete: () => boolean,
}

export const REQUEST_TYPES = {
    DELETE: 'DELETE MY PERSONAL INFORMATION',
    DO_NOT_SELL: 'DO NOT SELL MY PERSONAL INFORMATION',
    NONE: 'NONE SELECTED',
    REQUEST_COPY: 'GET MY PERSONAL INFORMATION',
}

export const PREFERRED_COMMUNICATION_TYPES = {
    MAIL: 'MAIL',
    NONE: 'NONE SELECTED',
    EMAIL: 'EMAIL',
}